import { useMatch } from 'react-router';

import PackHistoryDialog from '@/features/battery/workshop/PackHistoryDialog';

const PackHistoryPage = () => {
    const assetId = useMatch('/dialog/pack-history/:assetId')?.params.assetId;

    if (!assetId) {
        return null;
    }

    return <PackHistoryDialog />;
};

export default PackHistoryPage;
